module.exports = __webpack_public_path__ + "img/compass-03.2d1582c4.svg";